import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './CustomTooltip.scss';

class CustomTooltip extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    position: PropTypes.string,
    text: PropTypes.string
  };

  static defaultProps = {
    position: 'right'
  };

  toggleTooltip = (show) => this.setState({ show });

  render() {
    const { position, text } = this.props;

    const tooltipClassName = classNames(
      'tooltip',
      `tooltip--${position}`,
      'tooltip--show'
    );

    return (
      <div className="tooltip__wrapper">
        <div className={tooltipClassName}>
          <div className="tooltip__inner">{text && <I18n label={text} />}</div>
          <div className="tooltip__arrow" />
        </div>
        <div className="tooltip__content__wrapper">{this.props.children}</div>
      </div>
    );
  }
}

export default CustomTooltip;
